// extracted by mini-css-extract-plugin
export default {"container":"JZGT7uli5I3TNKIl9MOt","infoContainer":"BsZseLpWtNVbx3JjOUxP"};